<div class="relative mt-8 flex flex-auto flex-col items-center gap-8">
  @if (transaction(); as tx) {
    <div class="w-full max-w-3xl">
      <!-- Summary Card -->
      <div class="surface-default flex flex-col gap-4 rounded-xl border border-gray-5 p-6 shadow-sm">
        <div class="flex items-center justify-between">
          <div class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Transaction</span>
            <h1 class="text-2xl font-bold text-gray-12">
              {{ tx.amount | priceDisplay: tx.currency }}
            </h1>
          </div>
          <div
            class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-2.5 py-1 text-sm font-medium"
          >
            <div
              class="size-2 rounded-full"
              [class.bg-green-9]="tx.status === 'succeeded'"
              [class.bg-amber-9]="tx.status === 'pending' || tx.status === 'requires_action'"
              [class.bg-red-9]="tx.status === 'failed'"
            ></div>
            {{ tx.status | transactionStatusDisplay }}
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Details Grid -->
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <!-- Left side: User and Price -->
          <div class="flex flex-col gap-4">
            @if (tx.user) {
              <div class="flex flex-col gap-2">
                <span class="text-xs font-semibold uppercase tracking-wider text-gray-9">Abonné</span>
                <a
                  [routerLink]="['/users', tx.user._id]"
                  class="link flex flex-row items-center !p-0 !h-auto !min-w-0 cursor-pointer"
                >
                  <aura-avatar
                    [label]="tx.user.identity.firstName || ''"
                    [srcImage]="$safeNavigationMigration(tx.user.identity.avatar?.url)"
                    [size]="'s'"
                  />
                  <div class="ml-3 text-left">
                    <div class="font-medium text-gray-12">
                      {{ tx.user.identity.firstName }} {{ tx.user.identity.lastName }}
                    </div>
                    <div class="text-xs text-gray-10">{{ tx.user.contactInfos.email }}</div>
                  </div>
                </a>
              </div>
            }

            @if (tx.subscription) {
              <div class="flex flex-col gap-2">
                <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
                  >Abonnement associé</span
                >
                <a
                  [routerLink]="['/subscriptions', tx.subscription._id]"
                  class="link flex flex-row items-center !p-0 !h-auto !min-w-0 cursor-pointer"
                >
                  <div class="text-left">
                    <div class="font-medium text-gray-12">
                      {{ tx.subscription.plan.name || 'Sans offre' }}
                    </div>
                    <div class="text-xs text-gray-10">
                      ID: #{{ tx.subscription._id.toString() | slice: -6 }}
                    </div>
                  </div>
                </a>
              </div>
            }
          </div>

          <!-- Right side: Dates -->
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-1">
              <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
                >Date de la transaction</span
              >
              <div class="text-sm text-gray-12">
                {{ tx.date | luxonDate: 'dd/LL/yyyy HH:mm' }}
              </div>
            </div>
          </div>
        </div>

        @if (tx.metadata?.stripe; as stripe) {
          <mat-divider></mat-divider>

          <!-- Metadata -->
          <div class="flex flex-col gap-4">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-9"
              >Informations Stripe</span
            >
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              @if (stripe.paymentIntentId) {
                <div class="flex flex-col gap-1">
                  <span class="text-xs text-gray-10">ID de l'Intention de paiement (Payment Intent)</span>
                  <span class="font-mono text-sm text-gray-12 select-all">{{ stripe.paymentIntentId }}</span>
                </div>
              }
              @if (stripe.invoiceId) {
                <div class="flex flex-col gap-1">
                  <span class="text-xs text-gray-10">ID de la facture Stripe (Invoice)</span>
                  <span class="font-mono text-sm text-gray-12 select-all">{{ stripe.invoiceId }}</span>
                </div>
              }
            </div>
          </div>
        }

        <mat-divider></mat-divider>

        <!-- Metadata / Timeline -->
        <div class="flex flex-col gap-2 md:flex-row md:justify-between text-xs text-gray-9">
          <div>Créée le : {{ tx.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</div>
          <div>Mise à jour le : {{ tx.updatedAt | luxonDate: 'dd/LL/yyyy HH:mm' }}</div>
        </div>
      </div>
    </div>
  }
</div>
